export function getPayoutToneColor(tone) {
  switch (tone) {
    case "success":
      return "green";
    case "processing":
      return "blue";
    case "warning":
      return "orange";
    case "error":
      return "red";
    default:
      return "default";
  }
}

export function getPayoutModeColor(mode) {
  switch (mode) {
    case "transfer":
      return "geekblue";
    case "profit_sharing":
      return "purple";
    case "balance":
      return "gold";
    default:
      return "default";
  }
}

export function shouldShowShareableLimit(record) {
  if (!record.shareable_limit_info) {
    return false;
  }
  if (record.payout_info && record.payout_info.mode === "transfer") {
    return record.status === 6;
  }
  return (
    record.status === 6 ||
    record.shareable_limit_info.exceeds_shareable_limit
  );
}

export function getCommissionStatusColor(record) {
  if (record.payout_info && record.payout_info.tone) {
    return getPayoutToneColor(record.payout_info.tone);
  }
  switch (record.status) {
    case 1:
      return "green";
    case 4:
      return "blue";
    case 5:
      return "blue";
    case 6:
      return "orange";
    case 7:
      return "green";
    default:
      return "red";
  }
}
